module.exports = __webpack_public_path__ + "img/Card_diamond_2.b00cce8d.svg";